import { IFlatAddOnDescriptor } from "../types";

/**
 * The free Metabot AI grant. Granted and revoked through the internal tools
 * API, has no card and no route, and surfaces only as a billing line and an
 * estimate row — hence no builders and no `isVisible`. The grant is never on
 * sale, so the estimate has nothing to price: the row is the title and detail.
 */
const metabaseAi = {
  productType: "metabase-ai",
  kind: "flat",
  title: "Free Metabot AI",

  getEstimateRowItem: () => ({ detail: "Promo period" }),
  getBillingRowItem: () => ({ detail: "Promo period" }),
} satisfies IFlatAddOnDescriptor;

export default metabaseAi;
